import classNames from "classnames";
import ActivityPreviewLink from "PFApp/components/activity_commons/activity_preview_link";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { getProfileName } from "PFCore/helpers/profile";
import { Activity } from "PFTypes";

import css from "./content.module.scss";
import { Description } from "./description";

export type QuestionSuggestionContentProps = {
  activity: Activity;
  type?: string;
};

export const QuestionSuggestionContent = ({ activity, type }: QuestionSuggestionContentProps) => {
  const { profile } = activity;

  return (
    <div className={css.wrapper}>
      <ActivityPreviewLink activity={activity} profile={profile}>
        <div className={css.column}>
          <div className={css.row}>
            <ProfileAvatar profile={profile} size={50} />
            <div className={css.name}>
              <span>{getProfileName(profile)}</span>
              <span>{type === "question" ? " asks..." : " suggests..."}</span>
            </div>
          </div>
          <div
            className={classNames(css.bubble, {
              [css.bubbleSuggestion]: type === "suggestion"
            })}
          >
            <b>{activity.name}</b>
            <Description description={activity.description} />
          </div>
        </div>
      </ActivityPreviewLink>
    </div>
  );
};
